export const checkIsEmbeddedMode = (additionalInfoData: unknown): boolean =>
    !!additionalInfoData && typeof additionalInfoData === "object";
